import styled from 'styled-components';
import DollarSignSvg from 'library/icons/dollar-sign.svg';

export const StyledFilterDropdownOption = styled.div`
  white-space: nowrap;
  padding: 0.25em 0.5em;
  display: flex;
  align-items: center;
  text-align: left;
  ${(props) => (props.isTabbing ? '' : 'outline: none;')}
`;

export const StyledFilterDropdownInlineOption = styled.div`
  margin: 1em 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 46px;
  background-color: ${(props) =>
    props.activeFilter
      ? props.theme.colors.grey800
      : props.theme.colors.grey100};
  border-right: solid 1px white;
  ${(props) => props.first && 'border-radius: 4px 0 0 4px;'}
  ${(props) => props.last && 'border-radius: 0 4px 4px 0;'}

  svg {
    vertical-align: middle;
    color: ${(props) =>
      props.activeFilter
        ? props.theme.colors.grey100
        : props.theme.colors.grey800};
  }

  ${(props) => (props.isTabbing ? '' : 'outline: none;')}

  @media (max-width: ${(props) => props.theme.screen.tablet}px) {
    width: 25%;
    max-width: 75px;
  }
`;

export const SignContainer = styled.div`
  height: 27px;
`;

export const StyledSalarySign = styled(DollarSignSvg)`
  height: ${(props) => props.salaryFontSize}px;
`;

export const StyledLabel = styled.label`
  color: ${(props) => props.theme.colors.grey1};
  margin-left: 0.5em;
  font-weight: bold;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: ${(props) => props.theme.colors.grey800};

  @media (min-width: ${(props) => props.theme.screen.tablet}px) {
    color: ${(props) => props.theme.colors.yellow700};
  }
`;

export const StyledStar = styled.button`
  background: none;
  border: none;
  color: black;
  padding: 0;
  height: 23px;
  width: 23px;
  margin-left: 0.5em;
  font-size: 16px;

  &:not(:disabled):hover {
    background: none;
    border: none;
  }

  &:focus {
    outline: ${(props) =>
      props.isTabbing ? '-webkit-focus-ring-color auto 1px' : 'outline: none'};
  }
`;
